import {
  FeedbackStatus,
  ReportStage,
} from 'donor/portal/pages/FeedbackDashboard/api';
import { FeedbackType } from 'npo/pages/NPOFeedback/SubmitReady/utils';
import { ReportVisibility } from '../../auth/hooks/useUserActions';
import { ReportingType } from 'npo/pages/ReportsBeta/NewReport/api';

export interface ProgramManager {
  firstName?: string;
  lastName?: string;
  title?: string;
  phone?: string;
  accountId: number;
  userId: number;
  email?: string;
}

export interface Report {
  dbId: number;
  endDate: string;
  visibility: ReportVisibility;
  feedbackType: FeedbackType;
  fiscalYearStart: string; // "2022-11-26"
  fiscalYearEnd: string;
  name: string;
  programId: number;
  programManager?: null | ProgramManager;
  portfolioName: string;
  sponsorName: null;
  startDate: string;
  tasks: '';
  totalDonations: number;
  year: string; // "2023"
  errors: number; // 0
  warnings: number;
  programName: string;
  stage: ReportStage;
  status: FeedbackStatus;
  clonedFromId: number | null;
  version: 'v4' | 'v3' | null;
  cnOptedIn: boolean | null;
  level1DonorName?: string | null;
  level1Budget?: string | null;
  level1ReachSucceedMatch?: string | null;
  orgAnnualExpenses?: number | null;
  orgExpensesFiscalYear?: number | null;
  reportingType?: ReportingType | null;
  optedInFullReporting?: boolean | null;
}

export const getFullName = (
  firstName?: string,
  lastName?: string,
  unknownText = 'Unknown',
) => {
  return `${firstName || unknownText} ${lastName || ''}`;
};
